import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import translate from "../../../i18n/translate";
import WritingCenterCourse from "./FeatureAssets/WritingCenterCourse.json";
import "./writingCenter.scss";
import ProductivityToolsDescriptionContainer from "../../shared/ProductivityToolsDescriptionContainer/ProductivityToolsDescriptionContainer";

const WritingCenter = () => {
  const [writingCenterCourse, setWritingCenterCourse] = useState<any>([]);
  const sections = ["wc_feature_guideGroup1", "wc_feature_guideGroup2", "wc_feature_guideGroup3"];

  useEffect(() => {
    const { Tutorials } = WritingCenterCourse;
    const writingCenterTutorials = Tutorials.slice().filter(
      (tutorial: any) => tutorial.Type === "3" && tutorial.Title.includes("guideTitle")
    );
    setWritingCenterCourse(writingCenterTutorials);
  }, []);

  const getImage = (path: string) => {
    const imageTitle = path.split("/").pop();
    return `${process.env.REACT_APP_BLOB_STORAGE}/writingcenter/${imageTitle}`;
  };

  const getTutorialCard = (title: string, subIndex: number) => {
    const requestedTutorial: any = writingCenterCourse.slice().filter((tutorial: any) => tutorial.Title === title);

    if (requestedTutorial && requestedTutorial.length > 0) {
      const data = requestedTutorial[0];
      return (
        <Card className="each-tutorial-card" key={String(subIndex)} onClick={() => toWritingCenter(data.NodeId)}>
          <CardActionArea className="each-tutorial-card-action-area">
            <CardMedia
              component="img"
              image={getImage(data.ImageSource)}
              alt={`${data.Title}`}
              className="tutorial-image"
            />
            <CardContent className="tutorial-contents">
              <Typography variant="h5" className="tutorial-title">
                {translate(`wc_feature_${data.Title}`)}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      );
    }

    return <> </>;
  };

  const toWritingCenter = (nodeId: any) => {
    window.open(`${process.env.REACT_APP_PROGRESS_URL}/WritingCenter/${nodeId}?isSimplified=true`, "_blank");
  };

  return (
    <div className="wc-container-wrapper">
      <div className="wc-container">
        <ProductivityToolsDescriptionContainer
          headingTitle = "wc_feature_headline"
          featureDescription = "wc_feature_description"
          featureImg = {window.location.origin + "/images/" + "Feature_Illustrations/Writing-center.svg"}
        />
        <div className="wc-body-container">
          {sections.map((section: string, index: number) => (
            <div key={String(index)} className="each-section-box">
              <h5 className="each-section-title">{translate(`${section}`)}</h5>
              <div className="each-section-tutorial-container">
                {writingCenterCourse.map((course: any, subIndex: number) => (
                  <Fragment key={subIndex}>{getTutorialCard(`guideTitle${index + 1}${subIndex + 1}`, subIndex)}</Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WritingCenter;
